import {
  FetchMyLoungeThunk,
  loungeManagementBookLounge,
  loungeManagementFetchLoungesThunk,
  resourceManagementFetchValidLoungeByIdThunk,
} from './loungeManagementActions';
import { useAppAction, useAppSelector } from '../hooks';
import { LoungeManagementState } from './loungesManagementTypes';
import { LOUNGE_MANAGEMENT_NAMESPACE } from './loungesManagementReducer';

export function useResourceManagementSelector<
  T extends (state: LoungeManagementState) => any
>(selector: T): ReturnType<T> {
  return useAppSelector((state) =>
    selector(state[LOUNGE_MANAGEMENT_NAMESPACE])
  );
}

export const useLoungeManagementLounges = () =>
  useResourceManagementSelector((state) => {
    return state.lounges.filter((lounge) => lounge.id !== state.myLounge?.id);
  });

export const useLoungeManagementLoungesById = (id: number) =>
  useResourceManagementSelector((state) => {
    return state.lounges.find((item) => +item.id === +id);
  });

export const useMyLounge = () =>
  useResourceManagementSelector((state) => {
    return state.myLounge;
  });

export const useValidLounge = () =>
  useResourceManagementSelector((state) => {
    return state.lounge;
  });

export const useBookLoungeResourceAlloc = () =>
  useAppAction(loungeManagementBookLounge);

export const useFetchLoungeManagementLounges = () =>
  useAppAction(loungeManagementFetchLoungesThunk);

export const useFetchLoungeById = () => useAppAction(FetchMyLoungeThunk);

export const useGetValidLoungeById = () =>
  useAppAction(resourceManagementFetchValidLoungeByIdThunk);
